export { default as UiAccordion } from "./UiAccordion";
